import { useAppDispatch, useAppSelector } from "@/store/store"
import { Snackbar } from "@mui/material"
import { memo } from "react"
import { NavigationActions } from "./ducks/slice"

const anchorOrigin = {
  vertical: "top",
  horizontal: "right",
}

const CustomSnackbar = memo(() => {
  const snackbarContent = useAppSelector(({ navigation }) => navigation.user.snackbarContent)
  const dispatch = useAppDispatch()

  const dispatchClearSnackbar = () => dispatch(NavigationActions.clearSnackbar())

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      autoHideDuration={6000}
      message={<span id="message-id">{snackbarContent}</span>}
      onClose={dispatchClearSnackbar}
      open={!!snackbarContent}
    />
  )
})

export default CustomSnackbar
